<app-loader></app-loader>
<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding-top: 10px; padding-bottom: 40px;">
<app-main-container [title]="'Licensing'" [icon]="icon">
    <div class="row">
        <div style="width: 100%; padding-bottom: 15px;">
            <div class="row searchbar-row">
                <div class="col-md-9 searchbar-col">
                        <button class="btn btn-primary" (click)="onCreateNewClick()" *ngIf="userRole == AppSettings.USER_ROLES.ADMIN">
                            <i class="fa fa-plus" style="color: #fff;" aria-hidden="true"></i>  Create New
                        </button>
                    <mat-form-field>
                        <mat-label>Search Customer Code</mat-label>
                        <input
                            matInput
                            (keyup)="onSearch($event)"
                            placeholder="" [(ngModel)]="searchValue"
                            #input
                        />
                        </mat-form-field>
                        <!-- <div class="column-dropdown"> -->
                          
                        <!-- </div> -->
                </div>
                <div class="col-md-3 searchbar-col">
                  <label class="sts_lbl">Filter By</label>
                  <!-- <div class="column-dropdown"> -->
                    <mat-select
                      class="form-control"
                      (selectionChange)="onFilterByChange($event.value.value)"
                      id="platform"
                      [(ngModel)]="filterBy"
                      type="text"
                      placeholder="--Select--"
                    >
                      <mat-option
                        *ngFor="let item of filterByList"
                        placeholder="Select User"
                        [value]="item.value"
                      >
                        {{ item.displayValue }}</mat-option
                      >
                    </mat-select>
                  <!-- </div> -->
                </div>
            </div>
        </div>
        <app-table [columns]="columns" [tableData]="dataSource" [controls]="controls" [pageNo]="pagination.pageIndex" (controlButtonClick)="onControlButtonClick($event)" (pageChange)="onPageChange($event)" [totalRec]="totalRec" (buttonClick)="onButtonClick($event)" (sortStateChange)="onSortStateChange($event)" [resetData]="resetData"></app-table>
    </div>
    
</app-main-container>
</div>